<template>
  <v-card>
    <v-card-title>
      <p class="subtitle-1 font-weight-bold">Unlink this object?</p>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')">Cancel</v-btn>
      <v-btn color="primary" text @click="$emit('remove')" :loading="loading"
        >Unlink</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'RemoveConfirmation',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
